<script lang="ts" setup>
interface NavigationItem {
  label: string
  Title?: string
  Link?: string
  url?: string
  children?: NavigationItem[]
  Column1?: unknown[]
  Column2?: unknown[]
  Column3?: unknown[]
  Banner1?: unknown
  Banner2?: unknown
  AllTitle?: string
}

defineProps<{
  item: NavigationItem
  index: number
}>()

const {
  showSubmenu,
  toggleSubnavigation,
} = useNavigation()
</script>

<template>
  <div
    class="subnavigation"
    :class="{ 'subnavigation--open': index === showSubmenu }"
  >
    <div class="subnavigation__container">
      <div class="subnavigation__header">
        <button
          type="button"
          class="subnavigation__back"
          @click="toggleSubnavigation(index)"
        >
          <Icon
            name="icon:arrow"
            class="icon--arrow-left"
          />
          <span>{{ item.Title }}</span>
        </button>
      </div>

      <NavigationLevel2Banners
        v-if="item?.Banners?.length"
        class="subnavigation__content"
        :item="item"
      />
      <NavigationLevel2Content
        v-else
        class="subnavigation__content"
        :item="item"
      />

      <AppLink
        v-if="item?.AllTitle"
        :to="item.Link"
        class="subnavigation__title"
      >
        <span>{{ item.AllTitle }}</span>
      </AppLink>
    </div>
  </div>
</template>

<style>
@import url("~layers/app/components/Navigation/Level2.css");
</style>
